import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import _capitalize from 'lodash/capitalize';
import _cloneDeep from 'lodash/cloneDeep';
import {useCentralPageStyles} from '../centralPageStyles';
import {specialties as specialtiesReducer} from '../../../store/reducers/preferences';
import {Box, Stack, Typography} from '@mui/material';
import {OPTION_BUTTONS_DEFAULT_GAP} from '../../../components/header/agyleMenu/userProperties';

const UserActiveSpecialties = ({ showOnlyActive, showOnlyText }) => {
  const classes = useCentralPageStyles();
  const specialties = useSelector(specialtiesReducer);

  const [specialtiesToShow, setSpecialtiesToShow] = useState([]);

  useEffect(() => {
    let temp = _cloneDeep(specialties);

    if (showOnlyActive) {
      temp = temp.filter((spec) => !!spec?.isActive)
    }

    setSpecialtiesToShow(temp);
  }, [specialties, showOnlyActive])

  if (showOnlyText) {
    return !_isEmpty(specialtiesToShow) && specialtiesToShow?.[0]?.__description;
  }

  return (
    <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} flexWrap='wrap'>
      {!_isEmpty(specialtiesToShow) && specialtiesToShow.map((specialty, specialtyIndex) => (
        <Box key={specialtyIndex} className={classes.specChip}>
          <Typography variant='subtitle2' >
            {_capitalize(specialty?.__description || 'Unk')}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}

UserActiveSpecialties.propTypes = {
  showOnlyActive: PropTypes.bool,
  showOnlyText: PropTypes.bool,
}

UserActiveSpecialties.defaultProps = {
  showOnlyActive: false
}

export default UserActiveSpecialties;